import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
    @Input() allowDecimal: boolean = true;

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        const isDecimalKey = event.keyCode === 110 || event.keyCode === 190;
        // Allow: Backspace, Delete, Tab, Escape, Enter, arrows, Home, End, decimal (if enabled)
        if (
            [8, 9, 27, 13, 46].indexOf(event.keyCode) !== -1 ||
            (isDecimalKey && this.allowDecimal) ||
            // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
            ((event.keyCode === 65 || event.keyCode === 67 || event.keyCode === 86 || event.keyCode === 88) && (event.ctrlKey || event.metaKey)) ||
            // Allow: home, end, left, right, down, up
            (event.keyCode >= 35 && event.keyCode <= 40)
        ) {
            return;
        }
        // Prevent: if not a number key
        if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
            event.preventDefault();
        }
    }
}